import { combineReducers } from 'redux';

import {
  NOTIFICATION_SUCCESS,
  NOTIFICATION_WARNING,
  NOTIFICATION_ERROR,
  NOTIFICATION_INFO,
  PERSISTENT_NOTIFICATION_SUCCESS,
  PERSISTENT_NOTIFICATION_WARNING,
  PERSISTENT_NOTIFICATION_ERROR,
  PERSISTENT_NOTIFICATION_INFO,
  NOTIFICATION_RESET,
  NOTIFICATION_CLICKED,
  NOTIFICATION_RESETED,
} from '../actions/notifications/constants';
import createReducer from '../utils/createReducer';

const bars = createReducer([] as any[], {
  [NOTIFICATION_SUCCESS]: (draft, { payload }) => {
    draft.push({
      level: 'success',
      // @ts-expect-error ts-migrate(2532) FIXME: Object is possibly 'undefined'.
      message: payload.message,
      // @ts-expect-error ts-migrate(2532) FIXME: Object is possibly 'undefined'.
      restoreNotification: payload.restoreNotification,
      closeable: true,
    });
  },
  [NOTIFICATION_WARNING]: (draft, { payload }) => {
    draft.push({
      level: 'warning',
      // @ts-expect-error ts-migrate(2532) FIXME: Object is possibly 'undefined'.
      message: payload.message,
      // @ts-expect-error ts-migrate(2532) FIXME: Object is possibly 'undefined'.
      restoreNotification: payload.restoreNotification,
      closeable: true,
    });
  },
  [NOTIFICATION_ERROR]: (draft, { payload }) => {
    draft.push({
      level: 'error',
      // @ts-expect-error ts-migrate(2532) FIXME: Object is possibly 'undefined'.
      message: payload.message,
      // @ts-expect-error ts-migrate(2532) FIXME: Object is possibly 'undefined'.
      restoreNotification: payload.restoreNotification,
      closeable: true,
    });
  },
  [NOTIFICATION_INFO]: (draft, { payload }) => {
    draft.push({
      level: 'info',
      // @ts-expect-error ts-migrate(2532) FIXME: Object is possibly 'undefined'.
      message: payload.message,
      // @ts-expect-error ts-migrate(2532) FIXME: Object is possibly 'undefined'.
      restoreNotification: payload.restoreNotification,
      closeable: true,
    });
  },
  [PERSISTENT_NOTIFICATION_SUCCESS]: (draft, { payload }) => {
    draft.push({
      level: 'clone-success',
      // @ts-expect-error ts-migrate(2532) FIXME: Object is possibly 'undefined'.
      message: payload.notification.message,
      closeable: false,
      // @ts-expect-error ts-migrate(2532) FIXME: Object is possibly 'undefined'.
      targetLocation: payload.notification.targetLocation,
    });
  },
  [PERSISTENT_NOTIFICATION_WARNING]: (draft, { payload }) => {
    draft.push({
      level: 'warning',
      // @ts-expect-error ts-migrate(2532) FIXME: Object is possibly 'undefined'.
      message: payload.notification.message,
      closeable: false,
      // @ts-expect-error ts-migrate(2532) FIXME: Object is possibly 'undefined'.
      targetLocation: payload.notification.targetLocation,
    });
  },
  [PERSISTENT_NOTIFICATION_ERROR]: (draft, { payload }) => {
    draft.push({
      level: 'error',
      // @ts-expect-error ts-migrate(2532) FIXME: Object is possibly 'undefined'.
      message: payload.notification.message,
      closeable: false,
      // @ts-expect-error ts-migrate(2532) FIXME: Object is possibly 'undefined'.
      targetLocation: payload.notification.targetLocation,
    });
  },
  [PERSISTENT_NOTIFICATION_INFO]: (draft, { payload }) => {
    draft.push({
      level: 'info',
      // @ts-expect-error ts-migrate(2532) FIXME: Object is possibly 'undefined'.
      message: payload.notification.message,
      closeable: false,
      // @ts-expect-error ts-migrate(2532) FIXME: Object is possibly 'undefined'.
      targetLocation: payload.notification.targetLocation,
    });
  },
  [NOTIFICATION_RESET]: () => [],
  [NOTIFICATION_RESETED]: (draft, { payload }) => {
    // @ts-expect-error ts-migrate(2532) FIXME: Object is possibly 'undefined'.
    draft.push(payload.notification);
  },
});

const notificationClicked = createReducer(false, {
  // @ts-expect-error ts-migrate(2532) FIXME: Object is possibly 'undefined'.
  [NOTIFICATION_CLICKED]: (draft, { payload }) => payload.notificationClicked,
});

export default combineReducers({
  bars,
  notificationClicked,
});
